import { render } from "./main_w_item.vue?vue&type=template&id=abae4a78&scoped=true"
import script from "./main_w_item.vue?vue&type=script&lang=js"
export * from "./main_w_item.vue?vue&type=script&lang=js"

import "./main_w_item.vue?vue&type=style&index=0&id=abae4a78&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abae4a78"]])

export default __exports__